module.exports = __webpack_public_path__ + "assets/img/Indonesia.e7b22198.png";